import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function ContactUs() {
    const location = 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3548.700452328382!2d31.178494999999998!3d27.197149999999993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjfCsDExJzQ5LjciTiAzMcKwMTAnNDIuNiJF!5e0!3m2!1sen!2seg!4v1712577062978!5m2!1sen!2seg'

    useEffect(()=>{
        AOS.init({
          delay: 100, // values from 0 to 3000, with step 50ms
          duration: 1500, // values from 0 to 3000, with step 50ms
          easing: 'ease-in-sine', // default easing for AOS animations
        });
      })

  return (
    <section className='contactUs' id="contactUs">
        <div className='page-title title d-flex justify-content-center py-5'>
            <span className='mt-5 text-white fs-1'>CONTACT US</span>
        </div>
        <div className='container mt-5'>
            <div className='row m-0'>
                <div className='col-12 col-lg-6 my-5' data-aos="flip-right">
                    <div className='d-flex justify-content-center align-content-center flex-column text-center pb-2'>
                        <div className='title d-flex justify-content-start py-5'>
                            <span>EGYPT <small>(HEAD OFFICE)</small></span>
                        </div>
                        <div className='d-flex m-3'>
                            <span className='bg-color p-2 d-flex justify-content-center align-items-center' >
                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                                </svg>
                            </span>
                            <span className='mt-1 ms-5 fs-4 fw-bold text-start'>
                                <a href='https://www.facebook.com/UpperTelecomEg/'
                                target="_blank" rel="noreferrer" className='span-color txt'>UpperTelecomEg</a>
                            </span>
                        </div>
                        <div className='d-flex m-3'>
                            <span className='bg-color p-2 d-flex justify-content-center align-items-center' >
                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fillRule="currentColor" className="bi bi-geo-alt" viewBox="0 0 16 16">
                                    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/>
                                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                                </svg>
                            </span>
                            <span className='mt-1 ms-5 fs-4 fw-bold text-start txt'>4 Street no. 7, Takseem Elhokokyeen, Assiut, Egypt.</span>
                        </div>
                        <div className='d-flex m-3'>
                            <span className='bg-color p-2 d-flex justify-content-center align-items-center' >
                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fillRule="currentColor" className="bi bi-telephone" viewBox="0 0 16 16">
                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                                </svg>
                            </span>
                            <span className='mt-1 ms-5 fs-4 fw-bold phone'>
                                +201016304962
                                /
                                +201061780722
                            </span>
                        </div>
                        <div className='d-flex m-3'>
                            <span className='bg-color p-2 d-flex justify-content-center align-items-center' >
                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fillRule="currentColor" className="bi bi-envelope" viewBox="0 0 16 16">
                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
                                </svg>
                            </span>
                            <span className='mt-1 ms-5 fs-4 fw-bold email' style={{'word-break': 'break-word'}}>uppertelecomteam@uppertelecom.net</span>
                        </div>
                    </div>
                </div>
                <div className='col-12 col-lg-6 mb-5' data-aos="flip-left">
                    <div>
                        <iframe src={location} width="100%" height="600" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title='NMH Location'></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}